import React, { useState, useEffect } from 'react';
import { TextFieldCustom } from './ui/TextFieldCustom';
import { Box, Grid } from '@material-ui/core';
import SelectFieldCustom from './ui/SelectFieldCustom';
import { CheckBoxCustom } from './ui/CheckboxCustom';
import { useTranslation } from 'react-i18next';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { getCuCode } from '../utils';
export default function FormLoanDetails(props) {
    const { t, i18n } = useTranslation();
    const { control, getValues, setValue, watch } = useFormContext();
    const values = getValues();
    const [periodicPaymt, setPeriodicPaymt] = useState(0);
    const [ratesItems, setRatesItems] = useState([]);
    const { append, remove } = useFieldArray({
        control,
        name: 'applicants'
    });

    const CU_CODE = getCuCode();

    const isMortgage = values?.loan?.type === 'MTE' ? true : false;
    const isLineOfCredit = values?.loan?.type === 'LOC' ? true : false;
    const isAuthorizedoverDraft = values?.loan?.type === 'AOD' ? true : false;
    const { rates, loanPurpose, disableCalculate = false, rateText, rateTextFr } = props.data;
    const { loan } = values;
    let showPayment = true;
    if (disableCalculate || isLineOfCredit || isAuthorizedoverDraft) showPayment = false;
    const watchAmount = watch('loan.amount');
    const watchTerm = watch('loan.term');
    const watchFrequency = watch('loan.frequency');
    const watchAmortization = watch('loan.amortization');

    useEffect(() => {
        let tempRates = rates.filter((r) => r.type === values.loan.type);
        if (values.loan.product?.isPromo) {
            tempRates = tempRates.filter((r) => r.isPromo === true);
        }
        const ratesItems = tempRates.map((r) => {
            return { value: r.rateid, label: (i18n.language === 'fr' && r.descFr !== '' ? r.descFr : r.desc) };
        });
        setRatesItems(ratesItems);
        if (ratesItems.length === 1) {
            setValue('loan.termSelect', ratesItems[0].value);
            const { rate, term, amortization } = getTermAndInterestRate(ratesItems[0].value);
            setValue('loan.interestRate', rate);
            setValue('loan.term', term);
            setValue('loan.amortization', amortization/12);
            setValue('loan.rateid', ratesItems[0].value);
        } else {
            if (loan.termSelect !== '' && rates.filter((r) => r.rateid === loan.termSelect)[0].type !== loan.type)
                setValue('loan.termSelect', '');
        }
    }, []);
    const paymentfreq = t('los:paymentfreq', { returnObjects: true });

    useEffect(() => {
        const getPerodicPayment = () => {
            if (!loan.frequency || !loan.term || !loan.interestRate) return;
            // convert amorization in months
            loan.amortization *= 12;
            fetch(
                `${process.env.REACT_APP_BACKEND_URL}/v2/weblos/${CU_CODE}/payment/?amount=${loan.amount}&type=${loan.type}&frequency=${loan.frequency}&term=${loan.term}&amortization=${loan.amortization}&interestRate=${loan.interestRate}`
            )
                .then((res) => res.json())
                .then((payment) => {
                    setValue('loan.payment', payment);
                    setPeriodicPaymt(payment);
                });
        };

        getPerodicPayment();
    }, [watchAmount, watchTerm, watchFrequency, watchAmortization]);

    const handleClick = (event) => {
        if (event.target.checked) {
            append({
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                address: {
                    location: '',
                    city: '',
                    postalCode: '',
                    unit: '',
                    province: '',
                    occupationtype: '',
                    since: ''
                },
                email: '',
                phone: '',
                gender: '',
                employments: [
                    {
                        employer: '',
                        since: '',
                        earning: '',
                        phone: '',
                        occupation: '',
                        status: ''
                    }
                ]
            });
        } else {
            remove(1);
        }
    };

    const getTermAndInterestRate = (rateId) => {
        const { rate, term, amortization } = rates.find((r) => r.rateid === rateId);
        return { rate, term, amortization };
    };

    useEffect(() => {
        if (values?.loan?.type === 'MTE') {
            setValue('loan.amortization', 25);
        }
        if (isLineOfCredit || isAuthorizedoverDraft) {
            setValue('loan.showPayment', false);
        }
        setPeriodicPaymt(values?.loan?.payment);
    }, []);

    return (
        <div>
            <div className="mb-8">
                <div className="bg-white h-12 border border-l-4 rounded px-5 border-gray-300">
                    <div className="text-lg font-semibold mb-4 mt-2 text-gray-700">
                        {t('loanLabels.title')}
                    </div>
                </div>
            </div>
            <Grid container spacing={3}>
                {values?.loan?.type !== 'MTE' ? (
                    <Grid item md={6} xs={12}>
                        <SelectFieldCustom
                            name="loan.purpose"
                            label={t('loanLabels.purpose')}
                            items={loanPurpose}
                        />
                    </Grid>
                ) : null}
                <Grid item md={6} xs={12}>
                    <TextFieldCustom
                        name="loan.amount"
                        label={t('loanLabels.amount')}
                        money="true"
                        // onChange={(e) => getPerodicPayment(e.floatValue)}
                    />
                </Grid>
                <Grid item md={6} xs={12}>
                    <TextFieldCustom
                        name="loan.fundsNeededDate"
                        label={t('loanLabels.fundsNeededDate')}
                        type="date"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                {!isLineOfCredit && !isAuthorizedoverDraft ? (
                    <>
                        <Grid item md={6} xs={12}>
                            <SelectFieldCustom
                                name="loan.frequency"
                                label={t('loanLabels.pymtFreq')}
                                items={paymentfreq}
                                // onSelectedChange={(e) => {
                                //     getPerodicPayment('', e.target.value);
                                // }}
                            />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <SelectFieldCustom
                                name="loan.termSelect"
                                label={t('loanLabels.term')}
                                items={ratesItems}
                                onSelectedChange={(e) => {
                                    const { rate, term, amortization } = getTermAndInterestRate(e.target.value);
                                    setValue('loan.interestRate', rate);
                                    setValue('loan.term', term);
                                    setValue('loan.amortization', amortization/12);
                                    setValue('loan.rateid', e.target.value);
                                    // getPerodicPayment('', '', '', rate, term);
                                }}
                            />
                        </Grid>
                        <Grid item md={isMortgage ? 3 : 6} xs={isMortgage ? 6 : 12}>
                            <TextFieldCustom
                                name="loan.interestRate"
                                label={t('loanLabels.interestRate')}
                                prefix="%"
                                readOnly
                            />
                        </Grid>
                    </>
                ) : null}

                {isMortgage ? (
                    <Grid item md={3} xs={6}>
                        <TextFieldCustom
                            name="loan.amortization"
                            label={t('loanLabels.amortization')}
                            number="true"
                            isAllowed={(values) => {
                                const { formattedValue, floatValue } = values;
                                return (
                                    formattedValue === '' || (floatValue <= 25 && floatValue > 0)
                                );
                            }}
                        />
                    </Grid>
                ) : null}

                <Grid item md={12} xs={12} style={{ textAlign: 'left' }}>
                    <CheckBoxCustom
                        name="loan.coBorrower"
                        label={t('loanLabels.coBorrower')}
                        onClick={handleClick}
                    />
                </Grid>
                {/* {values?.loan?.type !== 'LOC' ? (
                    <Grid item md={12} xs={12}>
                        <SwitchCustom
                            name="loan.showPayment"
                            label={t('loanLabels.showEstimatedPymt')}
                        />
                    </Grid>
                ) : null} */}
            </Grid>
            <Box mb={2} />
            {showPayment ? (
                <div>
                    {/* <Box mb={3} />
                    <Grid container spacing={2}>
                        <Grid
                            item
                            container
                            md={12}
                            xs={12}
                            alignItems="center"
                            justify="center"
                            style={{ marginTop: '20px' }}>
                            <Paper
                                variant="outlined"
                                style={{
                                    padding: '15px',
                                    border: '1px solid #6a962a'
                                }}>
                                {t('loanLabels.periodicPymt')}{' '}
                                <Box
                                    style={{
                                        color: '#6a962a',
                                        fontFamily: 'Copse,sans-serif',
                                        fontSize: '1.4rem'
                                    }}
                                    component="span">
                                    {'$' + periodicPaymt}
                                </Box>
                            </Paper>
                        </Grid>
                        {rateText ? (
                            <Grid item md={12}>
                                <Typography
                                    variant="body2"
                                    component="p"
                                    style={{ fontSize: '12px', color: 'gray' }}>
                                    {rateText}
                                </Typography>
                            </Grid>
                        ) : null}
                    </Grid> */}
                    <div className="flex justify-center mt-5">
                        <div className="flex justify-center items-center bg-gray-100  h-20 w-full rounded-md">
                            <div className="text-center">
                                <span className="block text-lg text-gray-600">
                                    {' '}
                                    {t('loanLabels.periodicPymt')}
                                </span>
                                <span className="text-gray-600 text-3xl font-medium">
                                    {periodicPaymt ? <sup className="text-sm">$ </sup> : null}
                                    {periodicPaymt ? periodicPaymt : '-'}
                                </span>
                            </div>
                        </div>
                    </div>
                    {rateText || rateTextFr ? <div className="mt-4 text-gray-500 text-xs">{(i18n.language === 'fr' && rateTextFr !== '') ? rateTextFr : rateText}</div> : null}
                </div>
            ) : null}
        </div>
    );
}
